import { Color } from "three"
import _ from "lodash"
import TWEEN from "@tweenjs/tween.js"

import { BaseObject } from "maptalks.three"
import { Billboard } from "../object3d"

//TODO:: refactor this option logic later
const DEFAULT_ALTITUDE_FACTOR = 0.5
export const createHighlighBillboardController = (
  obj: Billboard,
  { altitudeFactor = DEFAULT_ALTITUDE_FACTOR } = {}
) => {
  const controller = { start: () => {}, clear: () => {} }
  if (!(obj instanceof Billboard)) return controller

  const altitude = obj.properties.default.altitude

  const newAltitude = _.clamp(altitude * altitudeFactor, 0, altitude)
  const tween = new TWEEN.Tween({ altitude })
    .to({ altitude: newAltitude }, 800)
    .easing(TWEEN.Easing.Quartic.Out)
    .onUpdate((newUpdate) => {
      obj.setLineHeight(newUpdate.altitude)
    })

  controller.start = () => {
    tween.start()
  }

  controller.clear = () => {
    tween.stop().to({ altitude }, 1600).startFromCurrentValues()
  }

  return controller
}

export const createHighlighExtrudeObjectController = (
  obj: BaseObject,
  { color }
) => {
  const controller = { start: () => {}, clear: () => {} }
  if (
    obj?.type !== "ExtrudePolygon" ||
    _.isNil(obj?.object3d?.material?.color) ||
    _.isNil(color)
  )
    return controller

  controller.start = () => {
    obj.object3d.material.color = new Color(color)
  }

  controller.clear = () => {
    const objectDefaultColor = _.get(obj, "properties.defaultColor")
    obj.object3d.material.color = new Color(objectDefaultColor)
  }

  return controller
}
